import React from "react";
import { Radio } from "antd";
import CustomTypography from "../../../commonComponents/CustomTypography";

const ExtensionListItem = ({ extension, selected, onSelect }) => {
  return (
    <div
      className={`flex items-center gap-3 p-3 ${
        selected
          ? "bg-[#E6F4FF] border border-solid border-[#91CAFF]"
          : "bg-white hover:bg-[#F5F5F5]"
      } cursor-pointer rounded w-full`}
      onClick={() => onSelect(extension.id)}
    >
      {/* Radio Button */}
      <Radio checked={selected} />

      {/* Extension Info */}
      <div className="flex-1">
        <CustomTypography variant="text" className="!text-black !font-normal">
          Extension {extension.number || extension.id}
        </CustomTypography>
      </div>
    </div>
  );
};

export default ExtensionListItem;
